import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import OtpInput from 'react-otp-input';
import CloseIcon from '@mui/icons-material/Close';

export default function VerificationView(props) {
    const { t } = useTranslation();
    const { palette, spacing } = useTheme();
    const { otp, setOtp } = props;

    const renderContent = () => {
        return (
            <>
                <Typography variant="subtitle2">
                    {props.title ? props.title : t('otp_title') + props.obfuscated_value + t('otp_title2')}
                </Typography>
                <Grid item xs={12} sx={{
                    "& div input": {
                        width: { xs: 43, md: 50 },
                        height: { xs: 50, md: 60 },
                    }
                }} my={2}>
                    <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        inputType="number"
                        renderInput={(inputProps) => (
                            <input
                                {...inputProps}
                                style={{
                                    border: '1px solid ' + palette.border.main,
                                    borderRadius: spacing(2),
                                    textAlign: 'center',
                                    MozAppearance: 'textfield', // Firefox
                                    WebkitAppearance: 'none',   // Safari/Chrome
                                    appearance: 'textfield',    // Fallback
                                }}
                            />
                        )}
                        containerStyle={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: spacing(1)
                        }}
                    />
                    <Grid item xs={12} marginTop={4}>
                        <Button
                            id="verification/btnSubmit"
                            fullWidth
                            size='large'
                            variant='contained'
                            onClick={props.onSubmit}
                        >
                            {t('AUTHENTICATE_AND_SIGN_IN')}
                        </Button>
                    </Grid>
                </Grid>
            </>
        );
    };

    return (
       
            <Dialog
                open={props.isOpen}
                onClose={props.onClose}
                maxWidth="sm"
                fullWidth
                aria-labelledby="verification-dialog-title"
                aria-describedby="verification-dialog-description"
            >
                <DialogTitle id="verification-dialog-title">
                    {t('authenticate')}
                    {props.onClose && (
                        <IconButton
                            aria-label="close"
                            onClick={props.onClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    )}
                </DialogTitle>
                <DialogContent>
                    {renderContent()}
                </DialogContent>
            </Dialog>
        
    );
}